import { ButtonBase } from "@mui/material";
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { addCommaToNumber, getDecoded } from "../../util";
import api from "../../api/apiClient";
import endpoints from "../../api/endpoints";

const Header = props => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(0);
  const [refresh, setRefresh] = useState(false);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  }

  const getAmount = async () => {
    const res = await api.get(endpoints.agent.getAgentAmount);
    if(res.code !== "200") return;
    setAmount(res.data.amount);
  }

  useEffect(() => {
    getAmount();
  },[refresh])

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex" style={{justifyContent: "space-between", width: "100%", alignItems: 'center'}}>
            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div style={{display: "flex", alignItems: 'center'}}>
              <h6 style={{color: config.color.textColor, margin: 0, marginRight: "60px"}}>
                  {getDecoded().clientId}
              </h6>
              <div style={{marginRight: "60px", display: 'flex', alignItems: "center"}}>
                <i class="fas fas fa-money-bill-wave" style={{fontSize: "16px", marginRight: "10px", color: 'gold'}}></i>
                <h5 style={{color: 'gold', margin: 0}}>
                  {addCommaToNumber(Number(amount))}
                </h5>
                <ButtonBase style={{marginLeft: "10px"}} onClick={()=> setRefresh(pre=> !pre)}>
                  <i className="mdi mdi-refresh" style={{fontSize: "20px"}}></i>
                </ButtonBase>
              </div>
              <div style={{marginRight: "15px"}}>
                <ButtonBase onClick={handleLogout}>
                  Logout
                </ButtonBase>
              </div>
            </div>


          </div>
        </div>
      </header>
    </React.Fragment>
  );
};



const mapStatetoProps = state => {};

export default connect(mapStatetoProps, {})(Header);
